import {
  useSourceRecordAggregate,
  useWebhookLogStatusCountsByCorporationId,
} from '@commenda/api/new-sales-tax/data-review';

interface UseIndirectTaxIntegrationSyncProgressStatusResult {
  isIntegrationSyncRecordDataProcessing: () => boolean;
  isIntegrationSyncRecordInProgressForIntegration: (
    rootfiCompanyId: number
  ) => boolean;
}

// TODO: backend — when an indirect-tax data-review endpoint exists, swap these
// underlying hooks. Logic itself is domain-neutral (webhook + source record
// counts).
export const useIndirectTaxIntegrationSyncProgressStatus = (
  corporationId: number
): UseIndirectTaxIntegrationSyncProgressStatusResult => {
  const { data: sourceRecordStatusAggregate } =
    useSourceRecordAggregate(corporationId);

  const { data: webhookRecordsStatusAggregate } =
    useWebhookLogStatusCountsByCorporationId(corporationId);

  const isIntegrationSyncRecordDataProcessing = (): boolean => {
    if (webhookRecordsStatusAggregate?.length) {
      const hasProcessingWebhooks = webhookRecordsStatusAggregate.some(
        (companyData) => {
          const counts = companyData.data;
          return (
            counts?.pending > 0 ||
            counts?.retryPending > 0 ||
            counts?.queued > 0 ||
            counts?.processing > 0
          );
        }
      );
      if (hasProcessingWebhooks) return true;
    }

    if (sourceRecordStatusAggregate) {
      return (
        sourceRecordStatusAggregate?.validationPending > 0 ||
        sourceRecordStatusAggregate?.validationInProgress > 0 ||
        sourceRecordStatusAggregate?.exportInProgress > 0 ||
        sourceRecordStatusAggregate?.readyForExport > 0
      );
    }

    return false;
  };

  const isIntegrationSyncRecordInProgressForIntegration = (
    rootfiCompanyId: number
  ): boolean => {
    if (webhookRecordsStatusAggregate?.length) {
      const integration = webhookRecordsStatusAggregate.find(
        (data) => data.rootfiCompanyId === rootfiCompanyId
      );

      return (
        Boolean(
          integration?.data?.processing && integration.data.processing > 0
        ) ||
        Boolean(integration?.data?.queued && integration.data.queued > 0) ||
        Boolean(
          integration?.data?.retryPending && integration.data.retryPending > 0
        ) ||
        Boolean(integration?.data?.pending && integration.data.pending > 0)
      );
    }

    return false;
  };

  return {
    isIntegrationSyncRecordDataProcessing,
    isIntegrationSyncRecordInProgressForIntegration,
  };
};
